import React from 'react';
import { ExtendedContentContainer, ExtendedContentType } from 'components/ExtendedContent/ExtendedContentContainer';
import ReadAloud from 'components/ReadAloud';

export const ReadAloudModalComponent = ({ src, readAloudInfo }) => {
  return <ExtendedContentContainer extendedContentType={ExtendedContentType.ReadAloud}>
    <ReadAloud src={src} readAloudInfo={readAloudInfo} />
  </ExtendedContentContainer>
};